import {
  GDSButtonProps,
  GDSIconProps,
  GDSTextActionProps,
} from '@leagueplatform/genesis-core';

export type Indicator =
  | 'NEW_TAB_INTERNAL'
  | 'NEW_WINDOW_INTERNAL'
  | 'EXTERNAL_LINK'
  | 'DISCLOSURE';

type IconTokenByStringProps = {
  [key: string]: GDSIconProps['icon'];
};

interface ButtonIndicatorTokenByStringProps {
  [key: string]: GDSButtonProps<'button'>['indicator'];
}

interface TextActionIndicatorTokenByStringProps {
  [key: string]: GDSTextActionProps<'a'>['indicator'];
}

const ButtonIconTokenByString: ButtonIndicatorTokenByStringProps = {
  NEW_TAB_INTERNAL: 'newTabInternal',
  NEW_WINDOW_INTERNAL: 'newWindowInternal',
  EXTERNAL_LINK: 'externalLink',
};

const TextActionIndicatorByString: TextActionIndicatorTokenByStringProps = {
  NEW_TAB_INTERNAL: 'newTabInternal',
  EXTERNAL_LINK: 'externalLink',
  DISCLOSURE: 'disclosure',
};

const IconTokenByString: IconTokenByStringProps = {
  NEW_WINDOW_INTERNAL: 'interfaceChevronForward',
  EXTERNAL_LINK: 'interfaceExternalLink',
  DISCLOSURE: 'tinyDisclosureIndicator',
};

const labelByIndicator = {
  NEW_TAB_INTERNAL: 'opens in a new tab',
  NEW_WINDOW_INTERNAL: 'opens in a new window',
  EXTERNAL_LINK: 'opens an external link',
  DISCLOSURE: '',
};

export const getButtonIconToken = (indicatorString: Indicator) =>
  ButtonIconTokenByString[indicatorString!];

export const getTextActionIndicatorIconToken = (indicatorString: Indicator) =>
  TextActionIndicatorByString[indicatorString!];

export const getIconToken = (indicatorString: Indicator) =>
  IconTokenByString[indicatorString!] as GDSIconProps['icon'];

export const getLabelByIndicator = (indicator: Indicator): string =>
  labelByIndicator[indicator];
